module.exports = __webpack_public_path__ + "img/refPansementDia.cdf4a782.jpg";